import { BaseService } from "@/api/services/baseService";
import type { WharfEntity } from "@/views/pages/logistics/wharf/type";
import { confirmable } from "@/utils/decorator/confirmable";
import type {Page, Port, PortHistoryVo, ShipDto} from "@zhihaoscm/entity";
import { shippingRequestHttp } from "@/api/index";
import type { PortPagingSelectorParams } from "@zhihaoscm/entity";
export class WharfService extends BaseService<WharfEntity, any, any, any> {
    public async getSelector(params: { page?: number; size?: number; portName: string }): Promise<WharfEntity[]> {
        const { data } = await this.service.get(`${this.path}/paging-selector`, { params });
        return data;
    }
    /**
     * 删除实例
     * @param id
     */
    @confirmable("是否删除此条码头信息？")
    public async delete(id: number | string) {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }

    /**
     * 查询码头 不分页
     * @param params
     */
    public async getPortList(params: { name: string }): Promise<Port[]> {
        const { data } = await this.service.get(`${this.path}/name`, { params });
        return data;
    }

    /**
     * 查询历史
     */
    public async getHistoryList(): Promise<PortHistoryVo[]> {
        const { data } = await this.service.get(`${this.path}/history`);
        return data;
    }

    /**
     * 清空历史
     */
    @confirmable("是否清空")
    public async clearHistory() {
        await this.service.delete(`${this.path}/all-history`);
    }

    /**
     * 删除
     * @param form
     */
    public async deleteHistory(form: PortHistoryVo) {
        await this.service.request({ method: "DELETE", url: `${this.path}/history`, data: form });
    }

    /**
     * 添加历史
     * @param form
     */
    public async addHistory(form: PortHistoryVo) {
        await this.service.post(`${this.path}/history`, form);
    }

    /**
     * 区域查询码头
     * @param form
     */
    public async extent(form: ShipDto): Promise<WharfEntity[]> {
        const { data } = await this.service.post(
            `${this.path}/extent`,
            {
                ...form
            },
            {
                timeout: 60000
            }
        );
        return data;
    }

    /**
     * 分页查询码头-城市下拉列表
     * @param {string} page 页码
     * @param {string} size 每页条数
     * @param {string} portName 全称、简称
     * @param {string} type 类型 1:码头 2:城市
     * @returns
     */
    public async pagingSelectorPort(
        page: number,
        size: number,
        portName: string,
        type: number | string
    ): Promise<{ data: { currentPage: number; list: WharfEntity[] } }> {
        return this.service.get(
            `${this.path}/paging-selector?page=${page}&size=${size}&portName=${portName}&type=${type}`
        );
    }

    public async getPagingSelectorPort(params: PortPagingSelectorParams): Promise<Page<Port>> {
        const { data } = await this.service.get(`${this.path}/paging-selector`, { params });
        return data;
    }
}
export const wharfService = new WharfService("/port", shippingRequestHttp.service);
